import liveswitch from "fm.liveswitch";
import ChannelConnectionEvents from "./ChannelConnectionEvents";
import Screenshare from "./Screenshare";
import Messager from "./Messager";
// import Channel from "../firestore/Channel";
// import { User } from "firebase/auth";
import SFUConnection from "./SFUConnection";
import { v4 } from "uuid";
import { releaseLocalMedia } from "../media/releaseLocalMedia";

export default class ChannelConnection {
    private localMedia!: liveswitch.LocalMedia;

    private client!: liveswitch.Client;
    public channel!: liveswitch.Channel;
    
    public screenshare!: Screenshare;
    public messager!: Messager;
    public isLocalVideoEnabled: boolean = true;
    public isLocalAudioEnabled: boolean = true;
    private hasLeft: boolean = false;
    public events: ChannelConnectionEvents = new ChannelConnectionEvents();
    public sfuConnection = new SFUConnection(this.events);

    public static localMediaConfig = new liveswitch.VideoConfig(640, 480, 30);

    public connectToChannel(channelId: string, user: {uid:string,email:""}, code?: string) {
        const gatewayUrl = process.env.REACT_APP_LIVESWITCH_GATEWAY_URL!;
        const applicationId = process.env.REACT_APP_LIVESWITCH_APPLICATION_ID!;
        const sharedSecret = process.env.REACT_APP_LIVESWITCH_SHARED_SECRET!;

        console.log("channelId:", channelId);


        if (!channelId) {
            throw new Error("Channel ID to join cannot be empty");
        }

        console.log(`Attempting to join channel ${channelId}`);

        this.client = new liveswitch.Client(gatewayUrl, applicationId, user.uid, v4(), v4(), ["web"]);
        this.client.setUserAlias(user.email!);
        const userAlias = localStorage.getItem('userAlias') || "HoloUser";
        this.client.setUserAlias(userAlias);

        let token = liveswitch.Token.generateClientRegisterToken(
            applicationId,
            this.client.getUserId(),
            this.client.getDeviceId(),
            this.client.getId(),
            this.client.getRoles(),
            [new liveswitch.ChannelClaim(channelId)],
            sharedSecret
        );
console.log("--------HERE----------");

        //const userIdToken = await user.getIdToken();

        //const registerToken = await Channel.getRegistrationToken(userIdToken, this.client, channelId, code);
        // await this.client.register(token);

        this.client.register(token).then((_) => {
            console.log(`Client ${this.client.getId()} registered`);

            token = liveswitch.Token.generateClientJoinToken(this.client, new liveswitch.ChannelClaim(channelId), sharedSecret);

            this.client.join(channelId, token).then((channel) => {
                this.channel = channel;
                console.log(`Successfully joined channel ${channel.getId()} as ${this.client.getUserAlias()}`);

                //this.startLocalMedia();
                // this.startLocalMedia()?.then((_) => {
                //     console.log("Local media started");
                // }).fail((ex) => this.logError(`${ex.message}. Make sure your webcam is plugged in and visible by your operating system.`));

                //this.openMcuConnection();

            })

        }).fail((ex) => this.logError("Registration failed: " + ex.message));


        // console.log(`Client ${this.client.getId()} registered`);

        //const joinToken = await Channel.getJoinToken(userIdToken, this.client, channelId);
        // const joinToken = await liveswitch.Token.generateClientJoinToken(this.client, new liveswitch.ChannelClaim(channelId), sharedSecret);

        //this.channel = await this.client.join(channelId, joinToken);
        //console.log(`Successfully joined channel ${this.channel.getId()} as ${this.client.getUserAlias()}`);
    }

    public openConnection(localMedia: liveswitch.LocalMedia) {
        // Allow leaveChannel to run again for this new session
        this.hasLeft = false;
        this.localMedia = localMedia;
        // LocalMedia is the source of truth when entering from the pre-join
        // screen. This also preserves a camera/microphone choice made there.
        this.isLocalVideoEnabled = !localMedia.getVideoMuted();
        this.isLocalAudioEnabled = !localMedia.getAudioMuted();
        
        // Start the screenshare manager
        this.screenshare = new Screenshare(this.channel, this.events, this.logError);
        
        // Start the message manager
        this.messager = new Messager(this.channel, this.events, this.logError);

        this.sfuConnection.openConnection(this.channel, localMedia);
    }

    public leaveChannel(): void {
        // Always release camera/mic, even if leave was already requested
        // (e.g. React Strict Mode remount or double navigate).
        const media = this.localMedia;
        this.localMedia = undefined as unknown as liveswitch.LocalMedia;
        releaseLocalMedia(media);

        if (this.screenshare) {
            try {
                this.screenshare.stopScreenshare();
            } catch {}
        }

        try {
            this.sfuConnection.closeConnection();
        } catch {}

        if (this.hasLeft) return;
        this.hasLeft = true;

        if (this.client && this.channel) {
            this.client.leave(this.channel.getId()).then(_ => {
                console.log("Left channel");

                this.client.unregister().then(_ => {
                    console.log("Unregistered");
                }).fail(ex => this.logError(ex.message));

            }).fail(ex => this.logError(ex.message));
        }
    }

    public getLocalMedia() {
        return this.localMedia;
    }

    public toggleLocalVideo(): void {
        this.isLocalVideoEnabled = !this.isLocalVideoEnabled;
        this.sfuConnection.setLocalVideoEnabled(this.isLocalVideoEnabled);
    }

    public toggleLocalAudio(): void {
        this.isLocalAudioEnabled = !this.isLocalAudioEnabled;
        this.sfuConnection.setLocalAudioEnabled(this.isLocalAudioEnabled);
    }

    public toggleFocusView(viewId: string) {
        this.sfuConnection.toggleFocusView(viewId);
    }

    public focusView(viewId: string | null) {
        this.sfuConnection.focusView(viewId);
    }

    private logError(error: string): void {
        console.log(error);
        this.events.notify("onerror", error);
    }
}
